export default __webpack_public_path__ + "static/media/guidestar-platinum-seal-of-transparency.3cd76d82.png";